<template>
  <Modal :show="show" @close="close()">
    <div v-if="success">
      <div class="modal-main mb-3">
        <div class="modal-header">
          <template v-if="voucherObj.logisticType == 'MICROBA_MANAGED'">
            <h2 class="modal-title">Your kit is on its way!</h2>
            <p
              class="text-center w-100"
            >Please follow the instructions in the kit to take your sample once it arrives.</p>
            <p class="text-center w-100" v-if="hasQuestionnaries">
              Your next step is to complete study-associated questionnaries for this sample. You will find these by
              clicking the My Research icon in the grey bar on the left of the screen or
              <router-link :to="{ name : 'Your kits' }">click here</router-link>.
              These questionnaires are available now. Please complete them as per the instructions provided by your project co-ordinator.
              <br />
              <br />Ensure that the 'Day of Sampling' questionnaire is completed on the day you take your sample.
            </p>
          </template>
          <template v-else>
            <h2
              class="modal-title"
            >You have successfully activated a new kit for {{ voucherObj.name }}.</h2>
            <p
              class="text-center w-100"
            >You should have been supplied with your kit so please take your sample when you are ready by following the instructions provided.</p>
            <p class="text-center w-100" v-if="hasQuestionnaries">
              Your next step is to complete study-associated questionnaries for this sample. You will find these by
              clicking the My Research icon in the grey bar on the left of the screen, or
              <router-link :to="{ name : 'Your kits' }">click here</router-link>.
              <br />These questionnaires are available now. Please complete them in line with the instructions of your project
              co-ordinator.
              <br />Ensure that the 'Day of Sampling' questionnaire is completed on the day you take your sample.
              <br />
            </p>
          </template>
        </div>
        <div class="row text-center">
          <div class="col-12">
            <a @click.prevent="goToResearch()" class="btn btn-primary" href="#">Proceed</a>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-body" v-if="!success">
      <template v-if="step == 'INTRO'">
        <div class="modal-main mb-3">
          <div class="modal-header text-center">
            <h2 class="modal-title">
              Welcome to the
              <span v-if="setProject">{{ setProject.researchProjectName }}</span> project.
            </h2>
            <p
              v-if="setProject && setProject.researchProjectLogisticsType === 'MICROBA_MANAGED'"
              class="text-center w-100"
            >Would you like a kit to be sent to you now?</p>
            <p v-else class="text-center w-100">Would you like to activate a sampling kit?</p>
          </div>
        </div>
        <div class="row text-center mt-5">
          <div class="col-12">
            <a class="btn btn-primary" href="#" @click.prevent="step = 'VOUCHER'">Yes</a>
            <a class="btn btn-outline-primary" href="#" @click.prevent="close">No</a>
          </div>
        </div>
      </template>
      <template v-else-if="step == 'ADDRESS'">
        <div class="modal-body">
          <div class="modal-header">
            <h2 class="modal-title">Send the kit to me now</h2>
          </div>

          <div class="modal-body">
            <p>This sampling kit is associated with the {{ voucherObj.name }} project.</p>
            <p>To have this kit sent to you now, please confirm your shipping details and click Proceed to confirm.</p>
            <p>Sending this kit will result in immediate dispatch to the address below.</p>
            <ModalAddress ref="address" v-model.sync="editedUser" />
          </div>

          <div class="row text-center mt-3 mb-2">
            <div class="col-12">
              <a
                class="btn btn-primary"
                :class="[errors.any() || !canSubmit ? 'disabled' : '']"
                href="#"
                v-on:click.prevent="redeemVoucher"
              >Proceed</a>
            </div>
          </div>

          <div class="row text-center mb-3 mt-2">
            <div class="col-12">
              <button class="btn plain" @click="step = 'LATER'; dontClaimKit = true">
                <em>I do not want to have my kit sent now</em>
              </button>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="step == 'ADDRESS'">
        <div class="modal-main mb-3">
          <div class="modal-header text-center">
            <h2 class="modal-title">Activate a kit</h2>
            <p class="text-center w-100">Please enter the voucher code that has been provided to you</p>
          </div>
        </div>

        <template v-if="error" name="slide-fade">
          <div class="row mb-2 ml-5 mr-5">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">{{ error }}</div>
            </div>
          </div>
        </template>

        <div class="row ml-5 mr-5">
          <div class="col-12">
            <input
              v-model="voucherCode"
              type="text"
              class="form-control"
              placeholder="Voucher code"
            />
          </div>
        </div>

        <div class="row text-center mt-5">
          <div class="col-12">
            <a
              class="btn btn-primary"
              :class="[errors.any() ? 'disabled' : '']"
              href="#"
              @click.prevent="checkVoucher"
            >Proceed</a>
          </div>
        </div>
      </template>
      <template v-else-if="step == 'LATER'">
        <div class="modal-body">
          <div class="modal-main mb-1">
            <div class="modal-header">
              <h2
                class="modal-title"
              >Head to your "My Research" page to activate your kit when you are ready</h2>
            </div>
          </div>
          <div class="row mb-2 ml-5 mr-5">
            <div class="col-12 text-center">
              <p>Please take into account that some projects have a limited recruitment capacity. We therefore recommend that you activate a kit as soon as possible to ensure you can participate in the study.</p>
            </div>
          </div>
          <div class="row text-center mt-5">
            <div class="col-12">
              <a
                class="btn btn-primary"
                :class="[errors.any() ? 'disabled' : '']"
                href="#"
                @click.prevent="close"
              >Close</a>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="step == 'VOUCHER'">
        <div class="modal-main mb-3">
          <div class="modal-header text-center">
            <h2 class="modal-title">Activate a kit</h2>
            <p class="text-center w-100">Please enter the voucher code that has been provided to you</p>
          </div>
        </div>

        <template v-if="error" name="slide-fade">
          <div class="row mb-2 ml-5 mr-5">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">{{ error }}</div>
            </div>
          </div>
        </template>

        <div class="row ml-5 mr-5">
          <div class="col-12">
            <input
              v-model="voucherCode"
              type="text"
              class="form-control"
              placeholder="Voucher code"
            />
          </div>
        </div>

        <div class="row text-center mt-5">
          <div class="col-12">
            <a
              class="btn btn-primary"
              :class="[errors.any() ? 'disabled' : '']"
              href="#"
              @click.prevent="checkVoucher"
            >Proceed</a>
          </div>
        </div>
      </template>
      <template v-else-if="step == 'PROJECT'">
        <div class="modal-main mb-3">
          <div class="modal-header">
            <h2 class="modal-title">Enter Participant Code</h2>
            <p class="text-center">
              This Voucher Code is associated with a new research project. Please enter the
              Participant code associated with this project
            </p>
          </div>
        </div>

        <template v-if="error" name="slide-fade">
          <div class="row mb-2 ml-5 mr-5">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">{{ error }}</div>
            </div>
          </div>
        </template>

        <div class="row mb-2 ml-5 mr-5">
          <div class="col-12">
            <input
              v-model="projectCode"
              type="text"
              class="form-control"
              placeholder="Participant code"
            />
          </div>
        </div>

        <div class="row text-center mt-5">
          <div class="col-12">
            <a
              class="btn btn-primary"
              :class="[errors.any() ? 'disabled' : '']"
              href="#"
              @click.prevent="checkProject"
            >Proceed</a>
          </div>
        </div>
      </template>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
import ModalSuccess from '@/components/models/components/ModalSuccess'
import ModalAddress from '@/components/models/components/ModalAddress'
import ModalSendAKit from '@/components/models/ModalSendAKit'
import ModalOrder from '@/components/models/ModalOrder'
import UserMixins from '@/mixins/userProfile'
import Hashids from 'hashids'

export default {
  name: 'ModalRedeemKit',
  props: ['kitID', 'activateModal', 'showIntro', 'setProject'],
  mixins: [UserMixins],
  extends: Modal,
  components: {
    Modal,
    ModalAddress,
    ModalSuccess,
    ModalSendAKit,
    ModalOrder
  },
  mounted: function () {
    this.checkIntro()
    this.editedUser = this.user
  },
  data: function () {
    return {
      projectCode: '',
      voucherCode: '',
      error: '',
      success: false,
      step: 'VOUCHER',
      voucherObj: null,
      getShippingAddress: false,
      dontClaimKit: false
    }
  },
  computed: {
    canSubmit: function () {
      return this.isValidAddress(this.editedUser) && this.voucher !== ''
    },
    hasQuestionnaries () {
      return (
        this.voucherObj.exerciseSurveyEnabled ||
        this.voucherObj.foodSurveyEnabled ||
        this.voucherObj.medicalSurveyEnabled ||
        this.voucherObj.mentalSurveyEnabled ||
        this.voucherObj.samplingSurveyEnabled ||
        this.voucherObj.infantDemographicAndMilkFeedingEnabled ||
        this.voucherObj.infantDayOfSamplingEnabled ||
        this.voucherObj.infantMedicalHistoryEnabled
      )
    },
    isActivation () {
      return this.activateModal
    },
    optionSpacing () {
      return 'col-md-4'
    },
    showChildOption () {
      return !this.user.underAge && !this.user.guardian
    },
    getKitId () {
      if (this.selectedKit) {
        return this.selectedKit.kitId
      }
      return ''
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE || false
    },
    successTitle () {
      if (this.activate) {
        return 'Great news, your kit is on its way!'
      }
      return 'Kit successfully redeemed'
    },
    successMessage () {
      if (this.activate) {
        return ''
      }
      return 'This kit is now available. Click "Select option" when you are ready to send this kit.'
    },
    kits: function () {
      return this.$store.state.GET_KITS_RESPONSE || []
    }
  },
  methods: {
    onShow: function () {
      this.step = 'VOUCHER'
      this.success = false
      this.projectCode = ''
      this.voucherCode = ''
      this.error = ''
      this.voucherObj = null
      this.checkIntro()
      // this.getShippingAddress = false
    },
    checkIntro () {
      if (this.showIntro) {
        this.step = 'INTRO'
      }
    },
    checkVoucher () {
      const payload = {
        voucher: this.voucherCode
      }
      let self = this
      self.error = ''
      this.$store
        .dispatch('checkResearchVoucher', payload)
        .then(success => {
          let hasProject = false
          for (let i = 0; i < self.kits.length; i++) {
            if (self.kits[i]['id'] === success.data.id) {
              hasProject = true
            }
          }
          self.voucherObj = success.data

          if (hasProject) {
            if (this.voucherObj.logisticType === 'MICROBA_MANAGED') {
              this.step = 'ADDRESS'
            } else {
              self.redeemVoucher()
            }
          } else {
            self.step = 'PROJECT'
          }
        })
        .catch(error => {
          console.log('ERROR', error)
          self.error =
            'You have entered an invalid voucher code. Please check the code or contact your project administrator.'
          // this.error = error.response.data.message
        })
    },
    checkProject () {
      let self = this
      let hashids = new Hashids(
        'FB8CCE167921467A',
        6,
        'BCDFGHJKLMNPQRSTUVWXYZ23456789'
      )
      let parts = hashids.decode(this.projectCode)

      if (parts[0]) {
        if (parts[0] === self.voucherObj.id) {
          self.joinProject()
        } else {
          self.error =
            'The participant code and Voucher Code provided are invalid or do not match. Please check the codes entered or contact your project administrator. '
        }
      } else {
        self.error =
          'The participant code is invalid. Please check the code entered or contact your project administrator. '
      }
    },
    joinProject () {
      const payload = {
        participantIdentifier: this.projectCode,
        userId: this.user.id
      }
      let self = this

      this.$store
        .dispatch('joinResearch', payload)
        .then(success => {
          console.log('Project', success)
          if (this.voucherObj.logisticType === 'MICROBA_MANAGED') {
            this.step = 'ADDRESS'
          } else {
            self.redeemVoucher()
          }
        })
        .catch(error => {
          console.log('ERROR', error)
          this.loading = false
          self.error = 'Invalid participant code.'
          // this.error = error.response.data.message
        })
    },
    redeemVoucher () {
      let self = this
      const payload = {
        voucher: this.voucherCode
      }

      this.$store
        .dispatch('checkVoucher', payload)
        .then(success => {
          // self.selectedKit = success.data
          console.log('Check voucher', success)
          self.processRedeem(success.data)
        })
        .catch(error => {
          console.log('ERROR', error)
          self.error =
            'You have entered an invalid voucher code. Please check the code or contact your project administrator.'
        })
    },
    processRedeem (kit) {
      const payload = {
        kitId: kit.id,
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        state: '',
        postcode: '',
        voucher: this.voucherCode,
        activate: false
      }
      let self = this

      this.$store
        .dispatch('redeemKitBasic', payload)
        .then(success => {
          if (this.voucherObj.logisticType === 'MICROBA_MANAGED') {
            this.activateKit(kit)
          } else {
            this.success = true
            this.$store.dispatch('getResearchKits')
          }
        })
        .catch(error => {
          console.log('ERROR', error)
          this.loading = false
          self.error = 'Unable to redeem voucher.'
          // this.error = error.response.data.message
        })
    },
    goToResearch () {
      this.$router.push({ name: 'Your kits' })
      this.close()
    },
    onClickActivate: function (kitID) {
      let self = this
      self.$store.dispatch('getResearchKits').then(success => {
        self.$emit('activateKit', kitID)
        self.close()
      })
    },
    activateKit (kit) {
      this.successLater = false
      const payload = {
        kitId: kit.kitId,
        firstName: this.editedUser.firstName,
        lastName: this.editedUser.lastName,
        addressLine1: this.editedUser.addressLine1,
        addressLine2: this.editedUser.addressLine2,
        suburb: this.editedUser.suburb,
        state: this.editedUser.state,
        postcode: this.editedUser.postcode
      }

      this.loading = true
      this.$store
        .dispatch('activateKit', payload)
        .then(success => {
          this.$store.dispatch('getResearchKits')
          this.success = true
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          // Refresh regardless
          this.$store.dispatch('getResearchKits')
          this.$store.dispatch('getSentKits')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  padding-top: 1rem;
  margin-top: 1rem;
}

.titleText {
  font-size: 22px;
}

img {
  margin: 0px auto;
}

.btn-option {
  border: 1px solid #eaeaea;
  border-radius: 10px;
  white-space: normal;
  text-align: center;
  padding: 13px;
  font-size: 14px;
}

a.btn-option:hover {
  border: 2px solid #f08c35;
  box-shadow: 0px 0px 4px #ccc;
}

a.btn-option.active {
  color: #01b299;
  border: 2px solid #01b299;
  box-shadow: 0px 0px 4px #ccc;
}

a.btn-option.active .dot {
  display: inline-block;
}

.dot {
  position: absolute;
  top: -10px;
  right: 27px;
  display: none;
  height: 25px;
  width: 25px;
  background-color: #01b299;
  color: #fff;
  border-radius: 50%;
  padding-left: 1px;
  padding-top: 4px;
}

.radioHint {
  margin-left: 30px;
  font-size: 14px;
}
.flex-center-vertically {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 400px;
}

.form-checkbox {
  label {
    color: #ff8708 !important;
  }
}

label {
  color: #ff8708 !important;
}

label.h6 {
  color: #000 !important;
  margin-bottom: 5px;
}

.optImg {
  max-width: 100px;
}

.voucherSubtitle {
  font-size: 14px;
}

.modal-address {
  padding-top: 2rem;
  padding-bottom: 1.5rem;
}

.modal-header {
  img {
    margin-bottom: 2rem;
  }
}

.emParagraph {
  font-size: 16px;
  font-weight: 500;
}

.buyText {
  font-size: 0.96rem;
  font-weight: lighter;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/application/research/models/ModalRedeemKit.vue